import {
  AcmEngine,
  BingEngine,
  CoreEngine,
  EpistemonikosEngine,
  EricEngine,
  EuropePmcEngine,
  GoogleEngine,
  GooglePatentEngine,
  GoogleScholarEngine,
  IdeasEngine,
  IeeexploreEngine,
  JstorEngine,
  LensEngine,
  LensPatentEngine,
  OpenAccessThesesAndDissertations,
  OpenAlexEngine,
  PlosEngine,
  PubMedEngine,
  SemanticScholarEngine,
  TripEngine,
  VhlEngine,
  YandexEngine
} from '@/formulate_queries/'
import { getEngineConfiguration } from '@/utils/engine-configurations-api'

export const POSSIBLE_ENGINES = [
  {
    name: 'Bing',
    selected: true,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new BingEngine(fieldSpecifiers),
    showIFrameResults: true,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example x-ray search to find AI/NLP experts in London',
    imgUrl: '../static/source-logo/bing-icon.svg',
    sampleUrl: '65f03b4ff1658cca4d8e8d06'
  },
  {
    name: 'Epistemonikos',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new EpistemonikosEngine(fieldSpecifiers),
    showIFrameResults: true,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example systematic search (Asynchronous and synchronous teleconsultation for diabetes care)',
    imgUrl: '../static/source-logo/epistemonikos-icon.svg',
    sampleUrl: '65f03eedf1658cca4d8e8d1b'
  },
  {
    name: 'IDEAS',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new IdeasEngine(fieldSpecifiers),
    showIFrameResults: true,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Examples of searches using phrases, fields, dates, etc. of Economics and Finance Research papers',
    imgUrl: '../static/source-logo/ideas-icon.svg',
    sampleUrl: '608966ae38b3120004b66c0e'
  },
  {
    name: 'Open Access Theses And Dissertations',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new OpenAccessThesesAndDissertations(fieldSpecifiers),
    showIFrameResults: true,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test OATD',
    imgUrl: '../static/source-logo/oatd-icon.svg',
    sampleUrl: '672e0870982b8547c7e47bcf'
  },
  {
    name: 'Open Alex',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new OpenAlexEngine(fieldSpecifiers),
    showIFrameResults: true,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test Open Alex',
    imgUrl: '../static/source-logo/open-alex-icon.svg',
    sampleUrl: '672e0ac1982b8547c7e47c2c'
  },
  {
    name: 'ACM Digital Library',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new AcmEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Advanced searches demonstrating operators and field tags',
    imgUrl: '../static/source-logo/acm-icon.svg',
    sampleUrl: '65f03951f1658cca4d8e8cff'
  },
  {
    name: 'CORE',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new CoreEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test Core',
    imgUrl: '../static/source-logo/core-icon.svg',
    sampleUrl: '672e0bec982b8547c7e47c81'
  },
  {
    name: 'ERIC',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new EricEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Advanced searches of the Education Resources Information Center showing operators and field tags',
    imgUrl: '../static/source-logo/eric-icon.svg',
    sampleUrl: '65f03c34f1658cca4d8e8d14'
  },
  {
    name: 'Europe PMC',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new EuropePmcEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test Europe PMC',
    imgUrl: '../static/source-logo/europe-pmc-icon.svg',
    sampleUrl: '672e183f982b8547c7e47e4c'
  },
  {
    name: 'Google',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new GoogleEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example x-ray search to find UX professionals in London',
    imgUrl: '../static/source-logo/google-icon.svg',
    sampleUrl: '65f03fd9f1658cca4d8e8d37'
  },
  {
    name: 'Google Patents',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new GooglePatentEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Examples demonstrating proximity, metadata searching, wildcards, negation, etc.',
    imgUrl: '../static/source-logo/google-patents-icon.svg',
    sampleUrl: '63d3f469062d890004a1903b'
  },
  {
    name: 'Google Scholar',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new GoogleScholarEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example systematic search (The Impact of Different Types and Doses of Statins)',
    imgUrl: '../static/source-logo/google-scholar-icon.svg',
    sampleUrl: '65f04117f1658cca4d8e8d42'
  },
  {
    name: 'IEEE Xplore',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new IeeexploreEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Examples demonstrating proximity, metadata searching, wildcards, negation, etc.',
    imgUrl: '../static/source-logo/ieee-icon.svg',
    sampleUrl: '65f0475ff1658cca4d8e8d51'
  },
  {
    name: 'JSTOR',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new JstorEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test JSTOR',
    imgUrl: '../static/source-logo/jstor-icon.svg',
    sampleUrl: '672e17e0982b8547c7e47ddc'
  },
  {
    name: 'Lens Patents',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new LensPatentEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'Examples demonstrating proximity, metadata searching, wildcards, negation, etc.',
    imgUrl: '../static/source-logo/lens-icon.svg',
    sampleUrl: '63d3f5d7062d890004a1903c'
  },
  {
    name: 'Lens Scholar',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new LensEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example systematic search using phrases, metadata searching, negation, etc.',
    imgUrl: '../static/source-logo/lens-icon.svg',
    sampleUrl: '65f04b13f1658cca4d8e8d5b'
  },
  {
    name: 'Public Library of Science (PLOS)',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new PlosEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test PLOS',
    imgUrl: '../static/source-logo/plos-icon.svg',
    sampleUrl: '672e1c26982b8547c7e47f03'
  },
  {
    name: 'PubMed',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new PubMedEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: true,
    tags: ['X-ray search'],
    useCase: 'An example systematic search using MeSH terms and field tags',
    imgUrl: '../static/source-logo/pubmed-icon.svg',
    sampleUrl: '65f04c48f1658cca4d8e8d62'
  },
  {
    name: 'Semantic Scholar',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new SemanticScholarEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test Semantic Scholar',
    imgUrl: '../static/source-logo/semantic-scholar-icon.svg',
    sampleUrl: '672e1c57982b8547c7e47f22'
  },
  {
    name: 'Trip Database',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new TripEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example systematic search (The Impact of Different Types and Doses of Statins)',
    imgUrl: '../static/source-logo/trip-icon.svg',
    sampleUrl: '65f04d2df1658cca4d8e8d6a'
  },
  {
    name: 'Virtual Health Library',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new VhlEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example search strategy to test Virtual Health Library',
    imgUrl: '../static/source-logo/vhl-icon.svg',
    sampleUrl: '672e1c87982b8547c7e47f40'
  },
  {
    name: 'Yandex',
    selected: false,
    enabled: true,
    searchEngineFn: fieldSpecifiers => new YandexEngine(fieldSpecifiers),
    showIFrameResults: false,
    showPolyglotQueries: false,
    tags: ['X-ray search'],
    useCase: 'An example x-ray search to find NLP experts in the USA',
    imgUrl: '../static/source-logo/yandex-icon.svg',
    sampleUrl: '65f04f08f1658cca4d8e8d71'
  }
  // {
  //   name: 'arXiv',
  //   enabled: true,
  //   searchEngineFn: fieldSpecifiers => new ArxivEngine(fieldSpecifiers),
  //   showIFrameResults: false,
  //   showPolyglotQueries: false
  // }
]

POSSIBLE_ENGINES.filter(engine => engine.name).forEach(engine => {
  getEngineConfiguration(engine.name)
    .then(response => {
      if (response &&
        response.response &&
        response.response.engineConfiguration
      ) {
        const data = response.response.engineConfiguration
        if (data.expectedFieldSpecifiers &&
          typeof data.expectedFieldSpecifiers === 'string' &&
          engine.searchEngineFn
        ) {
          engine.searchEngine = engine.searchEngineFn(JSON.parse(data.expectedFieldSpecifiers))
        }
      }
      if (!engine.searchEngine) {
        engine.searchEngine = engine.searchEngineFn()
      }
    })
    .catch(error => {
      console.warn(`Fetching config for ${engine.name} failed`, error)
    })
})

export const DEFAULT_ENGINE = POSSIBLE_ENGINES[0]



// WEBPACK FOOTER //
// ./src/utils/search-engines.js